import React, { FunctionComponent } from 'react';
import ReactDOM from 'react-dom';
import { Wrapper, Header, StyledModal, HeaderText, CloseButton, Content, Backdrop } from './styled';
import './popup.css'
import { Button, Typography } from '@mui/material';

// Code inspired by https://nainacodes.com/blog/create-an-accessible-and-reusable-react-modal
export interface PopupProps {
    isShown: boolean;
    hide: () => void;
    modalContent: JSX.Element;
    headerText: string;
    disableButton?: boolean;
}



export const Popup: FunctionComponent<PopupProps> = ({
    isShown,
    hide,
    modalContent,
    headerText,
    disableButton
}) => {

    function onHidePopup() {
        hide();
        const el = document.getElementById('popup-wrapper') as HTMLElement;
        el.setAttribute('class', 'fade-out');
    }

    const popup = (
        <React.Fragment>
            <Backdrop />
            <Wrapper id='popup-wrapper' className='fade-in'>
                <StyledModal>
                    <Header>
                        <HeaderText><Typography variant="h5">{headerText}</Typography></HeaderText>
                        {!disableButton ? <Button
                            variant='contained'
                            sx={{ "margin": "0px", "minWidth": "0px" }}
                            onClick={onHidePopup}>
                            X
                        </Button> : <></>}
                    </Header>
                    <Content>{modalContent}</Content>
                </StyledModal>
            </Wrapper>
        </React.Fragment>
    );

    return isShown ? ReactDOM.createPortal(popup, document.body) : null;
};
